export default {
  getAdditives: state => state.additives,
  getAccession: state => state.accession,
  getDiscount: state => state.discount,
  getContractType: state => state.contract_type,
  getShipping: state => state.shipping,
  getShippingName: state => state.shippingName,
  getDueDate: state => state.dueDate,
  getPayment: state => state.payment,
  getUUID: state => state.uuid,
  getContractAddress: state => state.contractAddress,
  getContractExternalId: state => state.contractExternalId,
  getContractPersonExternalId: state => state.personExternalId,
  getPaymentTypesOptions: (state) => state.paymentTypesOptions,
  getShippingMethodsOptions: (state) => state.shippingMethodsOptions,
  getDueDaysOptions: (state) => state.dueDaysOptions,
  getServiceOrigin: (state) => state.serviceOrigin
}
